// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const JOIN_STEP_SHAPES = [
  {
    stepType: PipelineStepType.JOIN,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      Left: {
        systemName: 'Left',
        displayName: 'Left',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      Right: {
        systemName: 'Right',
        displayName: 'Right',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      dataFrameName: {
        kind: 'string',
        required: true
      },
      joinType: {
        kind: 'enum',
        required: true,
        choices: [
          'INNER',
          'LEFT_OUTER',
          'RIGHT_OUTER',
          'FULL_OUTER',
          'NATURAL',
          'POSITIONAL'
        ]
      },
      joinConditions: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'shape',
          required: true,
          fields: {
            leftDataSourceColumn: {
              kind: 'columnReference',
              required: true,
              inputDataName: 'Left',
              validationOptions: null
            },
            rightDataSourceColumn: {
              kind: 'columnReference',
              required: true,
              inputDataName: 'Right',
              validationOptions: null
            }
          }
        }
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
